export enum TipoDescuento {
    PORCENTUAL = 'PORCENTUAL',
    ABSOLUTO = 'ABSOLUTO'
}
